import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';

@Injectable()
export class LocalUserService {

  getUser() {
    return JSON.parse(localStorage.getItem('userDetails'));
  }

  getFirstName() {
    return this.getUser().first_name;
  }

  getLastName() {
    return this.getUser().last_name;
  }

  getRole() {
    return this.getUser().role;
  }
  getBackgroundPackage() {
    return this.getUser().background_package;
  }

  getUserId() {
    return this.getUser().id;
  }

  getOrganizationId() {
    return this.getUser().organization_id;
  }

  getCheckrId() {
    return this.getUser().checkrId;
  }

  getMiddleName() {
    return this.getUser().middle_name;
  }

  getAddress() {
    return this.getUser().address;
  }

  getEmail() {
    return this.getUser().email;
  }

  getPhoneNumber() {
    return this.getUser().phone_number;
  }

  getToken() {
    return this.getUser().token;
  }
  getCurrentTime() {
    return this.getUser().current_time;
  }

  getState() {
    return this.getUser().state;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/localUser.ts